import type {DocSource} from '../../../../../../../api/model/response/documents/SearchResult';


export const useLimitedWidgetDocs = (sources: DocSource[] = [], sectionsData) => {
    const docsLists = sources.map(s=>sectionsData?.[s] || []);
    const contentfulSections = docsLists.filter(list=>list.length).length;

    switch (contentfulSections) {
    case 1:
      return (docsLists[0].length === 3 || docsLists[1]?.length === 3) ? docsLists.map(list => list.slice(0, 2)) : docsLists;
    case 2:
      return docsLists.map(list=>list.slice(0, 2));
    case 3:
      return [docsLists[0]].concat(docsLists.slice(1).map(list=>list.slice(0, 2)));
    default:
      return docsLists;
    }

};
